import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatDialogModule } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatListModule } from "@angular/material/list";
import { MatMenuModule } from "@angular/material/menu";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatSelectModule } from "@angular/material/select";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatTabsModule } from "@angular/material/tabs";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { FuseSharedModule } from "@fuse/shared.module";
import { DialogMessageComponent } from './dialog-message.component';
import { MomentModule } from 'ngx-moment';
import { RoleListProvider } from 'cw-backend';

@NgModule({
    declarations: [DialogMessageComponent],
    exports: [DialogMessageComponent],
    // ChatPanelService saiu daqui: agora e providedIn 'root', uma unica instancia
    // para o app inteiro. Manter aqui criava um segundo HTMLAudioElement.
    providers: [RoleListProvider],
    imports: [
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatPaginatorModule,
        MatSelectModule,
        MatSortModule,
        MatSnackBarModule,
        MatTableModule,
        MatDialogModule,
        MatTooltipModule,
        MatProgressSpinnerModule,
        MatCheckboxModule,
        MatAutocompleteModule,
        MatListModule,
        MatDatepickerModule,
        MatTabsModule,
        MatToolbarModule,
        MatMenuModule,
        MomentModule,
        FuseSharedModule,
    ],
})
export class DialogMessageModule {}
